import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  CardMedia,
  Checkbox,
  Typography,
  Box,
  Stack,
  Avatar,
  AvatarGroup,
  Popover,
  IconButton,
  Button,
} from "@mui/material";
import {
  Visibility as VisibilityIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  IosShare as IosShareIcon,
} from "@mui/icons-material";
import cardbackground from "../../assets/landing_page/new/Frame 2095584531.svg";
import moreicon from "../../assets/landing_page/new/morehorizontal.svg";
import { useDispatch } from "react-redux";
import { useNavigate, useOutletContext } from "react-router-dom";
import {
  setPlanForDelete,
  setPlanForEdit,
  setPlanForShare,
  setPlanForView,
} from "../../Slices/planslice";
import my_plan from "../../assets/landing_page/new/my_plan.png";
import sample from "../../assets/landing_page/new/Sample Plan.svg";
import shared from "../../assets/landing_page/new/Shared Plan.svg";
import ResourceIcon from "../../assets/planshare icons/Resources.png"

function CardPlan({ planData = [], getUsers }) {
  const { drawerOpen, toggleDrawer } = useOutletContext();
  const ProjectCard = ({ id, title, mppfile, plan_id, userId, createdBy, email_address, avatars, extraCount }) => {

    const [anchorEl, setAnchorEl] = useState(null);
    const [sharedData, setSharedData] = useState([]);

    const handleActionOpen = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleCloseAction = () => {
      setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const ids = open ? "user-options-popover" : undefined;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const SharedWithComponent = ({ sharedWithUsers, plan_id, user_id }) => {
      const maxVisibleUsers = 3;
      const relevantData = (sharedWithUsers || []).filter(
        (plan) => plan.org_user_id === user_id && plan.plan_id === plan_id
      );

      return (
        <Box display="flex" alignItems="center">
          {relevantData.slice(0, maxVisibleUsers).map((user, index) => (
            <Avatar
              key={index}
              alt={`Profile of ${user.shared_by_username}`}
              src={user.profile}
              sx={{
                width: 20,
                height: 20,
                marginLeft: index > 0 ? -1 : 0,
                border: "2px solid white",
                zIndex: maxVisibleUsers - index,
              }}
            />
          ))}
          {relevantData.length > maxVisibleUsers && (
            <Typography sx={{ marginLeft: 1, fontSize: "14px", fontWeight: 500 }}>
              +{relevantData.length - maxVisibleUsers}
            </Typography>
          )}
        </Box>
      );
    };
    const handleEdit = () => {
      dispatch(setPlanForEdit({ id, isEdit: true, table: false,
        isBlankPlan: mppfile === null, isTemplateToPlan: mppfile !== null }));

      navigate("/home/createplan");
      handleCloseAction();
    };
    const handleDelete = () => {
      dispatch(
        setPlanForDelete({
          id,
          isDelete: true,
          table: false,
          isBlankPlan: mppfile === null,
          isTemplateToPlan: mppfile !== null
        })
      );
      navigate("/home/createplan");
      handleCloseAction();
    };
    const handleView = () => {
      dispatch(setPlanForView({ id, isView: true, table: false }));
      navigate("/home/viewplan");
      handleCloseAction();
      // Close drawer when navigating to view plan
      if (typeof toggleDrawer === 'function' && drawerOpen) {
        toggleDrawer();
      }
    };
    const handleResourceView = () => {
dispatch(setPlanForView({ id, isView: true, table: false }));
      navigate("/home/viewplan", {
        state: {
          planId: plan_id,
          tab: "resources"
        }
      });
      handleCloseAction();
    };
    const handleShare = () => {
      dispatch(setPlanForShare({ id, isShare: true, table: false }));
      navigate("/home/plan-share-screen");
      handleCloseAction();
    };
    const username = localStorage.getItem("user_name");
    const userID = localStorage.getItem("user_id");
    return (
      <>
        <Card
          variant='outlined'
          sx={{
            width: 230,
            borderRadius: 2,
            margin: "10px", // Added margin to space the cards
          }}>
          <CardHeader
            title={
              <Stack
                direction='row'
                alignItems='center'
                justifyContent='space-between'>
                <Typography
                  variant='h6'
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "13px",
                    fontWeight: 600,
                    lineHeight: "14.52px",
                    textAlign: "left",
                    marginRight: "20px",
                    marginBottom: "10px",
                  }}>
                  {title}
                </Typography>
                <AvatarGroup
                  max={2}
                  sx={{ marginLeft: "auto", marginBottom: "10px" }}>
                  {avatars.map((avatar, index) => (
                    <Avatar
                      key={index}
                      // alt={`Avatar ${index + 1}`}
                      src={avatar}
                      sx={{ width: 20, height: 20 }}
                    />
                  ))}
                </AvatarGroup>
              </Stack>
            }
            sx={{ pb: 0, backgroundColor: "#E5EEFB66" }}
          />

          <CardContent sx={{ px: 1, py: 0, pb: "4px !important" }}>
            <Box
              sx={{
                position: "relative", // To ensure Button is positioned relative to this Box
                width: "100%",
                height: 80,
                "&:hover": {
                  color: "#0000001A", // Background color change on hover
                },
              }}>
              <CardMedia
                component='img'
                image={cardbackground}
                alt='Project Timeline'
                sx={{
                  height: "100%", // Keep the height full for the container
                  width: "100%", // Make sure the image fills the Box
                  borderRadius: 1,
                  objectFit: "cover",
                  backgroundColor: "#0000001A",
                  transition: "background-color 0.3s ease",
                }}
              />
              <CardMedia
                component='img'
                image={userId === userID ? my_plan : (email_address === "support@planshare.ai" ? sample : shared)} // Import path for your image
                alt={userId === userID ? "My Plan" : (email_address === "support@planshare.ai" ? "Sample Plan" : "Shared Plan")}
                sx={{
                  position: "absolute",
                  top: 0, // Adjust as needed
                  right: 0, // Adjust as needed
                  width: 100, // Image size
                  height: 24, // Image size
                  //borderRadius: "50%", // If you want it to be circular, you can remove this if not needed
                }}
              />

              <Button
                variant='contained'
                onClick={handleView}
                sx={{
                  display: "block", // Show on hover
                  position: "absolute",
                  top: "50%", // Center vertically
                  left: "50%", // Center horizontally
                  transform: "translate(-50%, -50%)", // Adjust position to be exactly in the center
                  backgroundColor: "transparent",
                  color: "#000",
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: 500,
                  //zIndex: 1,
                  boxShadow: "none",
                  textTransform: "none",
                  border: "1px solid #474747",
                  "&:hover": {
                    backgroundColor: "transparent",
                    border: "1px solid #474747",
                    color: "#000",
                    boxShadow: "none",
                  },
                }}>
                View Plan
              </Button>
            </Box>
            <Box
              sx={{
                borderBottom: "1px solid #ccc",
                backgroundColor: "#E5EEFB66",
              }}
            />

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "transparent",
                pt: 0.5, // Reduced top padding
                pb: 0.5,
              }}>
              <Box>
                <Typography
                  variant='body1'
                  color='textSecondary'
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "10px",
                    fontWeight: 500,
                    lineHeight: "12px",
                    textAlign: "left",
                    marginTop: "5px",
                    marginBottom: "2px",
                  }}>
                  Created by
                </Typography>
                <Typography
                  variant='body2'
                  sx={{
                    fontFamily: "Inter, sans-serif",
                    fontSize: "10px",
                    fontWeight: 500,
                    lineHeight: "12px",
                    textAlign: "left",
                    marginBottom: "2px",
                  }}>
                  {email_address}
                </Typography>
              </Box>
              <IconButton aria-label='settings' onClick={handleActionOpen} sx={{
                  padding: "4px", // Reduced padding of icon button
                }}>
                <img
                  src={moreicon}
                  alt='More options'
                  style={{ width: "20px", height: "20px" }}
                />
              </IconButton>
            </Box>
          </CardContent>
        </Card>

        <Popover
          id={ids}
          open={open}
          anchorEl={anchorEl}
          onClose={handleCloseAction}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "left",
          }}>
          <Box sx={{ p: 1, width: "130px" }}>
            <Button
              onClick={handleView}
              fullWidth
              sx={{
                justifyContent: "flex-start",
                textTransform: "none", // to keep the text lowercase

                color: "black", // you can adjust color as needed
              }}>
              <VisibilityIcon fontSize='small' sx={{ mr: 1 }} />
              <Typography
                id='view-user'
                variant='body1'
                sx={{
                  fontFamily: "Inter, sans-serif",
                  fontSize: "12px",
                  fontWeight: 500,
                  lineHeight: "14.52px",
                }}>
                View Plan
              </Typography>
            </Button>

            {userId === userID && (
              <>
                <Button
                  onClick={handleEdit}
                  fullWidth
                  sx={{
                    justifyContent: "flex-start",
                    textTransform: "none",

                    color: "black",
                  }}>
                  <EditIcon fontSize='small' sx={{ mr: 1 }} />
                  <Typography
                    id='edit-user'
                    variant='body1'
                    sx={{
                      fontFamily: "Inter, sans-serif",
                      fontSize: "12px",
                      fontWeight: 500,
                      lineHeight: "14.52px",
                    }}>
                    Edit Plan
                  </Typography>
                </Button>
                <Button
                  onClick={handleShare}
                  fullWidth
                  sx={{
                    justifyContent: "flex-start",
                    textTransform: "none",

                    color: "black",
                  }}>
                  <IosShareIcon fontSize='small' sx={{ mr: 1 }} />
                  <Typography
                    id='edit-user'
                    variant='body1'
                    sx={{
                      fontFamily: "Inter, sans-serif",
                      fontSize: "12px",
                      fontWeight: 500,
                      lineHeight: "14.52px",
                      textAlign: "left",
                    }}>
                    Share Plan
                  </Typography>
                </Button>
                <Button
                  onClick={handleDelete}
                  fullWidth
                  sx={{
                    justifyContent: "flex-start",
                    textTransform: "none",

                    color: "black",
                  }}>
                  <DeleteIcon fontSize='small' sx={{ mr: 1 }} />
                  <Typography
                    id='delete-user'
                    variant='body1'
                    sx={{
                      fontFamily: "Inter, sans-serif",
                      fontSize: "12px",
                      fontWeight: 500,
                      lineHeight: "14.52px",
                    }}>
                    Delete Plan
                  </Typography>
                </Button>
                <Button
                  onClick={handleResourceView}
                  fullWidth
                  sx={{
                    justifyContent: "flex-start",
                    textTransform: "none", // to keep the text lowercase
                    display: "flex",
                    gap: "7px",
                    color: "black", // you can adjust color as needed
                  }}>
                  <img src={ResourceIcon} fontSize='small' sx={{ mr: 1 }} height="23px" width="23px" />
                  <Typography
                    id='view-user'
                    variant='body1'
                    sx={{
                      fontFamily: "Inter, sans-serif",
                      fontSize: "12px",
                      fontWeight: 500,
                      lineHeight: "14.52px",
                      whiteSpace: "nowrap",
                    }}>
                    View Resources
                  </Typography>
                </Button>
              </>
            )}
          </Box>
        </Popover>
      </>
    );
  };
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        gap: 0, // Adds spacing between items

        marginTop: "0px",
      }}>
      {planData
        .sort((a, b) => {
          // Check if plan is a sample plan (from support@planshare.ai)
          const aIsSample = a.users && a.users.email === "support@planshare.ai";
          const bIsSample = b.users && b.users.email === "support@planshare.ai";
          
          // Sort sample plans first
          if (aIsSample && !bIsSample) return -1;
          if (!aIsSample && bIsSample) return 1;
          
          return 0;
        })
        .map((plan, index) => (
        <ProjectCard
          key={plan.id}
          id={plan.id}
          userId={plan.user_id}
          plan_id={plan.plan_id}
          mppfile={plan.unload_file_Path}
          title={plan.plan_name} // Taking title from planData
          createdBy={plan.created_by} // Assuming there's a createdBy field
          email_address={plan.users ? plan.users.email : ''}
          avatars={plan.avatars || []} // Default to an empty array if avatars is not provided
          extraCount={plan.extraCount || 0} // Default to 0 if extraCount is not provided
          sx={{
            flexBasis: "calc(25% - 20px)", // Each card will take up 25% of the row minus some margin
            margin: "10px", // Space around each card
          }}
        />
      ))}
    </Box>
  );
}

export default CardPlan;
